<template>
  <div align="center" class="wrapper">
    <ContactUsHeader />
    <div class="block-center mt-xl wd-xl">
      <div class="panel panel-dark panel-flat">
        <div class="panel-body">
          <p class="text-center pv"><strong>Change Password</strong></p>

          <form role="form" class="mb-lg" @submit.prevent="submit" >
            <div class="form-group has-feedback">
              <input
                v-model="password"
                id="password"
                type="password"
                placeholder="Your new password"
                autocomplete="off"
                required
                class="form-control"
              />
              <em class="form-icon icon-lock"></em>
            </div>
            <PasswordHint :password="password" />
            <div class="form-group has-feedback">
              <input
                v-model="passwordConfirmation"
                id="passwordConfirmation"
                type="password"
                placeholder="Confirm your new password"
                autocomplete="off"
                required
                class="form-control"
              />
              <em class="form-icon icon-lock"></em>
            </div>

            <button type="submit" class="btn btn-block btn-default btn-lg mt-xl" :disabled="!canSubmit">Change password</button>

            <div class="form-group has-feedback" v-bind:class="{ 'has-error': resetPasswordError }">
              <strong id="helpBlock6" class="help-block">{{ resetPasswordError }}</strong>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContactUsHeader from './ContactUsHeader';
  import PasswordHint from './PasswordHint';

  export default {
    name: 'ChangePassword',
    components: {
      ContactUsHeader,
      PasswordHint,
    },
    created() {
      const { code, email } = this.$route.query;
      if (!code && !email) {
        this.$router.push({ name: 'ResetPassword' });
      }
    },
    data() {
      return {
        password: '',
        passwordConfirmation: '',
        resetPasswordError: null,
      };
    },
    computed: {
      code() {
        return this.$route.query.code;
      },
      email() {
        return this.$route.query.email;
      },
      canSubmit() {
        return this.password === this.passwordConfirmation && this.isPasswordValid();
      },
    },
    methods: {
      isPasswordValid() {
        return this.password.length >= 8 &&
               /[A-Z]/.test(this.password) &&
               /[a-z]/.test(this.password) &&
               /[0-9]/.test(this.password) &&
               /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.password);
      },
      async submit() {
        if (!this.canSubmit) {
          return false;
        }
        const { email, password, code } = this;
        try {
          await this.$cognitoAuth.confirmResetPassword(email, code, password);

          this.$router.push({ name: 'Login', query: { email } });
        } catch (error) {
          this.resetPasswordError = error.message;
        }

        return false;
      },
    },
  };
</script>

<style>
  body {
    background-color: #fff;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wd-xl {
    width: 360px;
  }
  .text-red {
    color: #a94442;
  }
  .panel-body {
    padding: 15px 25px;
  }
  .form-icon {
    position: absolute;
    top: 10px;
    right: 12px;
  }
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?ac49ff6e